

import {
  Component, NgModule, OnDestroy, OnInit, EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ElementRef
} from '@angular/core';
import { DemoService } from '../../../demo.service';

import { Routes, RouterModule, Router } from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent, HttpEventType } from '@angular/common/http';



import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


import { SystemFile } from './../../../shared/models/systemFile.model';
import { Job } from './../../../shared/models/job.model';
import { Permission } from './../../../shared/models/permission.model';
import { SystemLog } from './../../../shared/models/sysLog.model';
import { DataUtil } from '@syncfusion/ej2-data';

import { NgForm } from '@angular/forms';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { Subscription } from 'rxjs';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Brand } from 'src/app/shared/models/brand.model';
import { UploadDiagnosticBatch, UploadDiagnosticFile, UploadDiagnosticsService } from 'src/app/services/upload-diagnostics.service';


import { DndDirective } from './../job-file-upload-widget/dnd.directives';
import { UploadProgressComponent } from './../job-file-upload-widget/upload-progress/upload-progress.component';

type UploadUiStatus = 'queued' | 'uploading' | 'uploaded' | 'saving' | 'logging' | 'complete' | 'failed';

interface UploadUiItem {
  local_id: string;
  file: File;
  name: string;
  size: number;
  progress: number;
  status: UploadUiStatus;
  status_label: string;
  can_retry: boolean;
  diagnostic_id?: string;
  batch_id?: string;
  file_create_id?: any;
  error_message?: string;
  upload_started_at?: number;
  upload_elapsed_ms?: number;
  upload_speed_mbps?: number;
}


@Component({
  selector: 'app-job-file-upload-widget3-attempts',
  templateUrl: './job-file-upload-widget3-attempts.component.html',
  styleUrls: ['./job-file-upload-widget3-attempts.component.scss']
})
export class JobFileUploadWidget3AttemptsComponent implements OnInit {

 // setup as observable?
 @Input() item_id?; // impliments on changes.
 @Input() item_data?; // if data.model is sent : Observable<any[]>;
 @Input() use_item_data?= 'no'; // if data.model is sent use this instead of item_id
 @Input() item_user_level_id?= '5'; // default to agent just in case
 @Input() item_brand_type_id?;
 @Input() show_buttons?= 'no'; // yes | no
 @Input() widget_title?= 'File Uploads';
 @Input() widget_size?; // side | abstract | full | attempt

 @Input() subject_id?: any;
 @Input() file_number?: any; // subject file number
 @Input() subject_number?: any; // subject file number
 @Input() brand_type_id?: number; // subject file number
 @Input() reference_number?: any; // subject file number
 
 @Input() subject_service_id?: any; // subject file number
 @Input() service_file_array?: any; // subject file number

 @Input() job_id: any;
 model: any; // File upload permissions model.
 job: any;
 file_model: SystemFile;

 @Output('onAdd') onAdd: EventEmitter<any> = new EventEmitter();
 @Input() is_attach_method?;

 @Input() attach_file_array_name?: any;

 //  :: file uploader Variables
 // map the result through the model
 create_file: SystemFile;
 //create_files: File[];
 create_sys_log: SystemLog;
 created_file: any;
 // permission_model: Permission;
 @Input() permission_model: any;


 // accept = '*'
 // files: File[] = []
   // public files: NgxFileDropEntry[] = [];
   // progress: number

  accept = '*'
 // files: File[] = []
  files: any[] = [];
  uploadItems: UploadUiItem[] = [];

   progress: number
   
   


 url = this.gfunc.php_apiURL_SSL + '/uploadFiles.php';
 url_outlook = this.gfunc.php_apiURL_SSL + '/uploadFiles_outlook.php';

 hasBaseDropZoneOver: boolean = false;
 httpEmitter: Subscription;
 httpEvent: HttpEvent<{}>;
 lastFileAt: Date;

 sendableFormData: FormData; // populated via ngfFormData directive

 dragFiles: any;
 validComboDrag: any;
 lastInvalids: any;
 fileDropDisabled: any;
 maxSize: any;
 baseDropValid: any;
 brand_types: any;
 brands: any;
 user_levels: any;
 tableData: any;
 created_file_name: string;
 file_edit_level: number;
 file_created_response: any;
 returned_created_file_id: any;
 system_log_created_response: any;
 allAgentRecipients: any[];
 assignedAgentsList2: any;
 sessionUserId: any;
 sessionUsername: any;
 sessionBrandId: any;
 all_router_details: string;
 current_base_route: string;
 brand_types_data: any;

 allUploadedFiles: any[]; // grab all the files uploaded into an array to set service_file_array

 myFormData:FormData //populated by ngfFormData directive
 current_brand_report_id;
 
 //// SyncFusion Dialog
 @ViewChild('ejDialog') ejDialog: DialogComponent;
 // Create element reference for dialog target element.
 @ViewChild('container', { read: ElementRef }) container: ElementRef;
 // The Dialog shows within the target element.
 
 file: any;
      // access the template form
      @ViewChild('jobForm') jobForm: NgForm;
 created_file_name_strip: any;
  file_data: Object;
  uploadDiagnosticBatch: UploadDiagnosticBatch;


  uploaded_file_data: any;
  drop_name: string;
  input: HTMLElement;
  set_files: FileList;
  drop_name2: any;

 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute, public toastr: HotToastService,
   vcr: ViewContainerRef, private router: Router, 
   public HttpClient: HttpClient,
   private fileUploader: FileUploaderService,
   private _mysqlService: MysqlService,
   private modalService: BsModalService,
   public datepipe: DatePipe,
   public gfunc: GlobalFunctionsService,
   private elem: ElementRef,
   private uploadDiagnostics: UploadDiagnosticsService,
 ) { 
   
   // Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));
  }







 // check for changes. to load data.
 ngOnChanges(changes) {
   if (changes.item_id) {
     // deal with asynchronous Observable result
     this.job_id = changes.item_id.currentValue;

     this.job = new Job();
     this.permission_model = new Permission();
     this.file_model = new SystemFile();
     this.getJob(this.job_id);
     this.getBrandTypes();
     // this.getBrands();
     // this.getFormUserLevels();
// setup permissions model
//this.permission_model = new Permission();






if (this.subject_id >= 1) { // prevents from loading on jobs card page as not needed. // stops javascript errors.
this.getSubjectAgentBrandsAssigned_comms(this.subject_id); // just in case
}


if (changes.permission_model){
 this.permission_model = changes.permission_model.currentValue; // sets from form of outside component

} else {
this.permission_model = {
job_id: this.job_id,
subject_id: this.subject_id,
created_by: this.gfunc.sessionUserId,
created_level: this.gfunc.sessionUserLevel,
file_brand_id: this.gfunc.sessionBrandId,
brand_type_id: this.gfunc.sessionBrandTypeId,
assigned_to_agents: JSON.stringify(this.allAgentRecipients)
} as Permission;
}// end else if

   }
   if (changes.subject_id) {
    this.subject_id = changes.subject_id.currentValue;
    this.subject_number = this.subject_number;
   //  this.getSubjectAgentBrandsAssigned_comms(this.subject_id);
   }


  //  if (changes.attach_file_array_name){
  //   this.attach_file_array_name = changes.attach_file_array_name.curretValue;
  //   }
    


 }


 ngOnInit() {

// Setup some form names and fileholding name
this.drop_name = "fileDropRef_attempt";
this.drop_name2 = this.attach_file_array_name;
console.log('drop2 Name:' , this.drop_name2)

// this.input = null;
const input = null as HTMLInputElement;
// let input = document.getElementById('fileDropRef_attempt');
let input2 = document.getElementById(this.drop_name2);

   

   // input?.addEventListener('change', event => {
   //   const target = event.target as HTMLInputElement;
   
     
   //   console.log(target.files);

   //   // this.prepareFilesList(target.files);
   // });
  //  if (this.attach_file_array_name == ''){ }
input?.addEventListener('change', event => {
 // 👇️ inline type assertion
//  this.set_files = null;
 const result = (event.target as HTMLInputElement).files;
 this.set_files = result;
 this.uploadDiagnosticBatch = this.uploadDiagnostics.startBatch('job-file-upload-widget3-attempts', result, {
   jobId: this.item_id,
   subjectId: this.subject_id,
   route: this.router.url
 });
 this.uploadDiagnostics.markBatchStage(this.uploadDiagnosticBatch, 'change_event_received', {
   inputId: this.drop_name,
   attachFileArrayName: this.attach_file_array_name
 });
 console.log('Reslts: ', result);
// this.prepareFilesList(result);
// this.dropped(result);
// this.fileBrowseHandler(result);
this.fileBrowseHandler(this.set_files, this.uploadDiagnosticBatch);

// this.uploadFiles(result); // see if the old script works


// this.uploaded_file_data = (event.target as HTMLInputElement).files[];
// // this.uploaded_file_data  = this.elem.nativeElement.querySelector('#fileDropRef_attempt').files;
// console.log( JSON.stringify(this.uploaded_file_data))

});
 



                    // input2?.addEventListener('change', event => {
                    //   // 👇️ inline type assertion
                    // //  this.set_files = null;
                    //   const result = (event.target as HTMLInputElement).files;
                    //   this.set_files = result;
                    //   console.log('Reslts: ', result);
                    // // this.prepareFilesList(result);
                    // // this.dropped(result);
                    // // this.fileBrowseHandler(result);
                    //     // this.fileBrowseHandler(this.set_files);

                    //   //
                    //   let files2 = this.elem.nativeElement.querySelector(this.drop_name2).files;

                    //   const  count_of_items2 = files2.length;
                    //   // //  let res = data[0];
                    //   //  // Run the job data queries.
                      
                    //   //  // need to do a loop of subject_billing items (.length)
                    //   //  for(let i=0;  i < count_of_items; i++) {
                    //   //   let res = files[i];
                    //   // // do some totals and tax calculations.
                      
                    //   // formData.append('files', res.file[i], res.file[i].name); // file is the name of the variable in the php process script
                      
                    //   //  }
                      
                      
                      
                    //   let c = 0; // count
                    //   // loop 5 times
                    //   while (c < count_of_items2) {
                      
                      
                    //           //   // apends the value to the form.
                    //           const formData = new FormData()
                    //           this.sendableFormData = formData;
                    //           formData.append('job_id', this.item_id);
                    //           let files2 = this.elem.nativeElement.querySelector(this.drop_name2).files;
                    //           // let files = this.elem.nativeElement.querySelector('#' + this.drop_name).files;
                    //           // let files = this.set_files;
                              
                            
                    //           let file2 = files2[c];
                    //           formData.append('file', file2, file2.name); // file is the name of the variable in the php process script
                    //               const headers = new HttpHeaders({
                    //                 'security-token': 'mytokenMEOW'
                    //               })
                    //               this.http.post(this.url_outlook, formData, { headers: headers, responseType: 'text' })
                    //               .subscribe(data => {
                    //               // Sanitized logo returned from backend
                    //               console.log(data);
                      
                    //               // this.toastr.success('file uploaded: ' + c);
                    //               this.createJobFileData([], files2 ,file2);
                    //               })
                      
                      
                      
                      
                    //   // this.jobPlaintiffVars_dropdown_data.push(
                    //   //   {Category: 'Job Plaintiff ' + c, Name: 'Plaintiff ' + c + ' Name', insertValue: '${job_plaintiff_' + c + '_name}'},
                    //   //   {Category: 'Job Plaintiff ' + c, Name: 'Plaintiff ' + c + ' Type', insertValue: '${job_plaintiff_' + c + '_type_name}'},
                    //   // );
                    //   // only run the simulator once, but loop through this and upload and create the files
                    //   if (c == 0){
                    //   this.uploadFilesSimulator(c);
                    //   }
                      
                    //   c++;
                    //   } // end plainiff while loop

                

                    //   // use above instead.
                    //   // this.uploadFiles(result); // see if the old script works
                      
                      
                    //   // this.uploaded_file_data = (event.target as HTMLInputElement).files[];
                    //   // // this.uploaded_file_data  = this.elem.nativeElement.querySelector('#fileDropRef_attempt').files;
                    //   // console.log( JSON.stringify(this.uploaded_file_data))
                      
                    //   });

  



              // input2?.addEventListener('change', event => {
              //   // 👇️ inline type assertion
              // //  this.set_files = null;
              // const result2 = (event.target as HTMLInputElement).files;
              // this.fileBrowseHandler(result2);
               
              //   }); 
    




 }




onFileInputChange(event: Event) {
 const input = event.target as HTMLInputElement;
 const result = input && input.files ? input.files : null;
 this.set_files = result;
 this.uploadDiagnosticBatch = this.uploadDiagnostics.startBatch('job-file-upload-widget3-attempts', result, {
   jobId: this.item_id,
   subjectId: this.subject_id,
   route: this.router.url
 });
 this.uploadDiagnostics.markBatchStage(this.uploadDiagnosticBatch, 'change_event_received', {
   inputId: this.drop_name,
   attachFileArrayName: this.attach_file_array_name
 });
 console.log('Reslts: ', result);
 this.fileBrowseHandler(this.set_files, this.uploadDiagnosticBatch);

 if (input) {
   input.value = '';
 }
}

manualUploader($event){
  // this.input = null;
const input = document.getElementById(this.drop_name);
// let input = document.getElementById('fileDropRef_attempt');

   

   // input?.addEventListener('change', event => {
   //   const target = event.target as HTMLInputElement;
   
     
   //   console.log(target.files);

   //   // this.prepareFilesList(target.files);
   // });


input?.addEventListener('change', event => {
 // 👇️ inline type assertion
//  this.set_files = null;
 const result = (event.target as HTMLInputElement).files;
 this.set_files = result;
 const manualBatch = this.uploadDiagnostics.startBatch('job-file-upload-widget3-attempts-manual', result, {
   jobId: this.item_id,
   subjectId: this.subject_id,
   route: this.router.url
 });
 this.uploadDiagnostics.markBatchStage(manualBatch, 'manual_uploader_change_event_received', {
   inputId: this.drop_name
 });
 console.log('Reslts: ', result);
// this.prepareFilesList(result);
// this.dropped(result);
// this.fileBrowseHandler(result);
this.fileBrowseHandler(this.set_files, manualBatch);

// this.uploadFiles(result); // see if the old script works


// this.uploaded_file_data = (event.target as HTMLInputElement).files[];
// // this.uploaded_file_data  = this.elem.nativeElement.querySelector('#fileDropRef_attempt').files;
// console.log( JSON.stringify(this.uploaded_file_data))

});
}




/**
  * on file drop handler
  */
onFileDropped($event) {





console.log(JSON.stringify('Event: ', $event))
 
//  this.prepareFilesList($event.target.files);
}

/**
* handle file from browsing
*/
fileBrowseHandler(files, uploadBatch?: UploadDiagnosticBatch) {
 console.log(JSON.stringify('Files: ', this.files))
 this.prepareFilesList(files, uploadBatch);
 
 
//  this.uploaded_file_data = [{
//   ...files,
//   attach_file_array_name: this.attach_file_array_name
// }]


}

/**
* Delete file from files list
* @param index (File index)
*/
deleteFile(index: number) {
 this.uploadItems.splice(index, 1);
 this.files.splice(index, 1);
 console.log(JSON.stringify(this.files))
}

/**
* Simulate the upload process
*/
uploadFilesSimulator(index: number) {
 setTimeout(() => {
  console.log(this.files.length);
   if (index === this.files.length) {
        // clear
        // reset the form
            this.sendableFormData.delete;
            this.files = [];
            this.file = '[]';
     return;
   } else {
     const progressInterval = setInterval(() => {
       if (this.files[index].progress === 100) {
         clearInterval(progressInterval);
 

        // //  this.uploadFiles(this.files[index]); // see if the old script works
        // //   // apends the value to the form.
        //         const formData = new FormData()
        //         this.sendableFormData = formData;
        //         formData.append('job_id', this.item_id);
        //         let files = this.elem.nativeElement.querySelector('#fileDropRef_attempt').files;
             
             
        //         let file = files[index];
        //         formData.append('file', file, file.name); // file is the name of the variable in the php process script
        //             const headers = new HttpHeaders({
        //               'security-token': 'mytokenMEOW'
        //             })
        //             this.http.post(this.url_outlook, formData, { headers: headers, responseType: 'text' })
        //             .subscribe(data => {
        //             // Sanitized logo returned from backend
        //             console.log(data);

        //             this.toastr.success('file uploaded: ' + index);
        //             this.createJobFileData([], this.files[index]);
        //             })

           
            this.uploadFilesSimulator(index + 1);


       //  this.deleteFile(index); // now reove the file
        // this.files[index].progress = 100;
       } else {
         this.files[index].progress += 5;
       }
     }, 100);
   }
 }, 1000);
}

/**
* Convert Files list to normal array list
* // @param files (Files List)
*/
prepareFilesList(files, uploadBatch?: UploadDiagnosticBatch) {
 if (!files || files.length <= 0) {
   this.uploadDiagnostics.markBatchStage(uploadBatch, 'no_files_selected');
   return;
 }

 const selectedFiles = Array.from(files) as File[];
 const batch = uploadBatch || this.uploadDiagnostics.startBatch('job-file-upload-widget3-attempts', selectedFiles, {
   jobId: this.item_id,
   subjectId: this.subject_id,
   route: this.router.url
 });
 this.uploadDiagnosticBatch = batch;

 selectedFiles.forEach((file, index) => {
   (file as any).progress = 0;
   const uploadDiag = this.uploadDiagnostics.startFile(batch, file, index, 'prepareFilesList');
   const uploadItem = this.addUploadItem(file, uploadDiag);
   this.uploadSingleFile(file, selectedFiles, uploadDiag, uploadItem);
 });
}

private addUploadItem(file: File, uploadDiag?: UploadDiagnosticFile): UploadUiItem {
 const uploadItem: UploadUiItem = {
   local_id: 'upload-' + Date.now() + '-' + Math.random().toString(36).substring(2, 8),
   file,
   name: file ? file.name : '',
   size: file ? file.size : 0,
   progress: 0,
   status: 'queued',
   status_label: 'Queued',
   can_retry: false,
   diagnostic_id: uploadDiag ? uploadDiag.id : null,
   batch_id: uploadDiag ? uploadDiag.batchId : null
 };

 this.uploadItems.push(uploadItem);
 return uploadItem;
}

private uploadSingleFile(file: File, selectedFiles: File[], uploadDiag: UploadDiagnosticFile, uploadItem: UploadUiItem): void {
 const formData = new FormData();
 this.sendableFormData = formData;
 formData.append('job_id', this.item_id);
 formData.append('file', file, file.name);

 let headers = new HttpHeaders({
   'security-token': 'mytokenMEOW'
 });
 headers = this.uploadDiagnostics.headers(headers, uploadDiag);

 uploadItem.upload_started_at = Date.now();
 this.setUploadItemStatus(uploadItem, 'uploading', 'Uploading file', 1);
 this.uploadDiagnostics.markFileStage(uploadDiag, 'php_upload_request_start', {
   url: this.url_outlook
 });

 const request = new HttpRequest('POST', this.url_outlook, formData, {
   headers,
   reportProgress: true,
   responseType: 'text'
 });

 this.http.request(request).subscribe(event => {
   if (event.type === HttpEventType.UploadProgress) {
     const total = event.total || uploadItem.size || 0;
     if (total > 0) {
       uploadItem.progress = Math.max(1, Math.min(85, Math.round((event.loaded / total) * 85)));
     }
     return;
   }

   if (event instanceof HttpResponse) {
     const elapsed = uploadItem.upload_started_at ? Date.now() - uploadItem.upload_started_at : null;
     uploadItem.upload_elapsed_ms = elapsed;
     uploadItem.upload_speed_mbps = elapsed && elapsed > 0
       ? Number(((uploadItem.size / 1024 / 1024) / (elapsed / 1000)).toFixed(2))
       : null;
     console.log(event.body);
     this.uploadDiagnostics.markFileStage(uploadDiag, 'php_upload_request_success', {
       response: event.body
     });
     this.setUploadItemStatus(uploadItem, 'uploaded', 'Uploaded; saving file record', Math.max(uploadItem.progress, 88));
     this.createJobFileData([], selectedFiles, file, uploadDiag, uploadItem);
   }
 }, error => {
   this.uploadDiagnostics.markError(uploadDiag, 'php_upload_request_error', error);
   this.setUploadItemFailed(uploadItem, 'Upload failed: ' + (error && error.message ? error.message : error));
   this.toastr.error('Error Uploading File: ' + (error && error.message ? error.message : error));
 });
}

retryUploadItem(uploadItem: UploadUiItem): void {
 if (!uploadItem || uploadItem.status !== 'failed') {
   return;
 }

 const batch = this.uploadDiagnostics.startBatch('job-file-upload-widget3-attempts-retry', [uploadItem.file], {
   jobId: this.item_id,
   subjectId: this.subject_id,
   route: this.router.url
 });
 const uploadDiag = this.uploadDiagnostics.startFile(batch, uploadItem.file, 0, 'retryUploadItem');
 uploadItem.diagnostic_id = uploadDiag.id;
 uploadItem.batch_id = uploadDiag.batchId;
 uploadItem.error_message = null;
 uploadItem.can_retry = false;
 uploadItem.upload_elapsed_ms = null;
 uploadItem.upload_speed_mbps = null;
 this.uploadSingleFile(uploadItem.file, [uploadItem.file], uploadDiag, uploadItem);
}

private setUploadItemStatus(uploadItem: UploadUiItem, status: UploadUiStatus, label: string, progress?: number): void {
 if (!uploadItem) {
   return;
 }

 uploadItem.status = status;
 uploadItem.status_label = label;
 uploadItem.can_retry = status === 'failed';
 if (progress !== undefined && progress !== null) {
   uploadItem.progress = Math.max(uploadItem.progress || 0, Math.min(100, progress));
 }
}

private setUploadItemFailed(uploadItem: UploadUiItem, message: string): void {
 if (!uploadItem) {
   return;
 }

 uploadItem.status = 'failed';
 uploadItem.status_label = 'Failed';
 uploadItem.error_message = message;
 uploadItem.can_retry = true;
}

get uploadSummary() {
 const total = this.uploadItems.length;
 const completed = this.uploadItems.filter(item => item.status === 'complete').length;
 const failed = this.uploadItems.filter(item => item.status === 'failed').length;
 const uploading = this.uploadItems.filter(item =>
   item.status === 'queued' ||
   item.status === 'uploading' ||
   item.status === 'uploaded' ||
   item.status === 'saving' ||
   item.status === 'logging'
 ).length;

 return { total, completed, failed, uploading };
}

get showUploadTechnicalDetails(): boolean {
 try {
   return Number(this.gfunc.sessionUserLevel) <= 2 || window.localStorage.getItem('uploadUiDebug') === '1';
 } catch {
   return Number(this.gfunc.sessionUserLevel) <= 2;
 }
}

formatUploadSeconds(milliseconds: number): string {
 if (!milliseconds && milliseconds !== 0) {
   return '';
 }

 return (milliseconds / 1000).toFixed(2);
}

private uploadDiagnosticForLog(uploadDiag?: UploadDiagnosticFile, uploadItem?: UploadUiItem): any {
 const diagnostic = this.uploadDiagnostics.forLog(uploadDiag, 'system_log_dispatch') || {};
 return {
   ...diagnostic,
   browser_upload_elapsed_ms: uploadItem ? uploadItem.upload_elapsed_ms : null,
   browser_upload_seconds: uploadItem && uploadItem.upload_elapsed_ms
     ? Number((uploadItem.upload_elapsed_ms / 1000).toFixed(2))
     : null,
   browser_upload_speed_mbps: uploadItem ? uploadItem.upload_speed_mbps : null,
   browser_upload_progress: uploadItem ? uploadItem.progress : null,
   browser_upload_status: uploadItem ? uploadItem.status : null
 };
}

/**
* format bytes
* @param bytes (File size in bytes)
* @param decimals (Decimals point)
*/
formatBytes(bytes, decimals) {
 if (bytes === 0) {
   return '0 Bytes';
 }
 const k = 1024;
 const dm = decimals <= 0 ? 0 : decimals || 2;
 const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
 const i = Math.floor(Math.log(bytes) / Math.log(k));
 return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}








 // Functions
 getJob(job_id) {
   this._demoService.getJobID(job_id).subscribe(
     data => {
       this.job = data;
       let res = data[0];

       /*       // Run the job data queries.
            this.getJobType(res.job_type_id);
            this.getJobPlaintiffType(res.job_plaintiff_type_id);
            this.getJobTypeLocation(res.job_type_location_id);
            this.getJobTypeCourt(res.job_type_court_id);
            this.getJobTypeDocument(res.job_type_document_type_id);
            this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
            this.getReportBrand(res.brand_report_id);
            this.getInvoiceBrand(res.brand_invoice_id); // get company invoice brand */

     },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 // permissions


 setFilePermissions(model) {
   // need to set file submission data to set corret file/access upon upload.
 };

 getBrandTypes() {
   this._demoService.getBrandBrandTypes().subscribe(
     data => { 
       this.brand_types = data; 
     
     },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }
 getBrands() {
   this._demoService.getBrands().subscribe(
     data2 => {
       this.brands = data2;
       // console.log(data2);
     },
     err => console.error(err),
     () => console.log('done loading User Brands')
   );
 }
 getFormUserLevels() {
   this._demoService.getFormUserLevels().subscribe(
     data2 => {
       this.user_levels = data2;
       console.log(data2);
     },
     err => console.error(err),
     //  () =>  console.log('done loading User Levels')
   );
 }




 // :: File upload

 // upload files

 cancel() {
   this.progress = 0
   if (this.httpEmitter) {
     console.log('cancelled')
     this.httpEmitter.unsubscribe()
   }
 }

 uploadFiles(result, uploadBatch?: UploadDiagnosticBatch) {
   // uploadFiles(): Subscription {
   // apends the value to the form.



   
//   // apends the value to the form.
 const formData = new FormData()
 this.sendableFormData = formData;
 formData.append('job_id', this.item_id);

//   // this.changeFile(file);

let files = this.elem.nativeElement.querySelector('#fileDropRef_attempt').files;
// let formData = new FormData();

// need to setup a loop for each so I think will back this file up and create a new one that will work as muiltiple correccly......

let file = files[0];
const uploadDiag = this.uploadDiagnostics.startFile(
  uploadBatch || this.uploadDiagnostics.startBatch('job-file-upload-widget3-attempts-legacy', files, {
    jobId: this.item_id,
    subjectId: this.subject_id,
    route: this.router.url
  }),
  file,
  0,
  'legacy_uploadFiles'
);
formData.append('file', file, file.name); // file is the name of the variable in the php process script



// let  count_of_items = files.length;
// //  let res = data[0];
//  // Run the job data queries.

//  // need to do a loop of subject_billing items (.length)
//  for(let i=0;i < count_of_items; i++) {
//   let res = files[i];
// // do some totals and tax calculations.

// formData.append('files', res.file[i], res.file[i].name); // file is the name of the variable in the php process script

//  }




 // formData.append('file[]', result[0].file as Blob, 'testfile')

//   // this.sendableFormData.append('subject_id', this.subject_id);
//         //  const req = new HttpRequest<FormData>(
//         //    'POST',
//         //    this.url,
//         //    formData, {
//         //    reportProgress: true, responseType: 'text'
//         //  },
//         //  );

//       // Headers
     let headers = new HttpHeaders({
       'security-token': 'mytokenMEOW'
     })
     headers = this.uploadDiagnostics.headers(headers, uploadDiag);
     this.uploadDiagnostics.markFileStage(uploadDiag, 'legacy_php_upload_request_start', {
       url: this.url_outlook
     });

  this.http.post(this.url_outlook, formData, { headers: headers, responseType: 'text' })
  .subscribe(data => {
    // Sanitized logo returned from backend
    console.log(data);
    this.uploadDiagnostics.markFileStage(uploadDiag, 'legacy_php_upload_request_success', {
      response: data
    });
   
    this.toastr.success('file uploaded');

  }, error => {
    this.uploadDiagnostics.markError(uploadDiag, 'legacy_php_upload_request_error', error);
  })

   
       //   this.sendableFormData.append('job_id', this.job_id);
       //  // this.sendableFormData.append('subject_id', this.subject_id);
       //   const req = new HttpRequest<FormData>(
       //     'POST',
       //     this.url,
       //     this.sendableFormData, {
       //     reportProgress: true, responseType: 'text'
       //   },
       //   );

       //   return this.httpEmitter = this.HttpClient.request(req)
       //     .subscribe(
       //       event => {
       //         this.httpEvent = event;
       //         if (event instanceof HttpResponse) {
       //           delete this.httpEmitter;
       //           console.log('request done', event);
       //           // clears the form for upload
       //           this.files.length = 0;
       //           this.refreshList(); // refresh list.
       //         }
       //       },
       //       error => alert('Error Uploading Files: ' + error.message)
       //     )
 }

 private refreshList(): void {
   // notice the update here for traces
   this.fileUploader.getJobFiles(this.job_id).subscribe(res => this.displayTableData(res));

 }

 private displayTableData(data: any): void {
   this.tableData = data.json();
 }

 deleteJobFile(filename, job_id) {
   if (confirm('Are you sure you want to delete this file? ')) {
     this._mysqlService.deleteJobFile(filename, job_id).subscribe(
       data => {
         // this.getTraceNotes(this.trace_id);
         this.refreshList();
         return true;
       },
       error => {
         console.error('Error deleting Job File!');
         return console.log(error);
       }
     );
   }
 }


 getDate() {
   return new Date();
 }
 // :: end file upload




 // :: File Upload Database and Insert Log

 // New file and document system Permisions on Job file Uploads
 createJobFileData(model, files, file_sent, uploadDiag?: UploadDiagnosticFile, uploadItem?: UploadUiItem) {

let entry = file_sent;
   this.setUploadItemStatus(uploadItem, 'saving', 'Saving file record', 90);
   this.uploadDiagnostics.markFileStage(uploadDiag, 'file_metadata_prepare_start');
   // Loop through array
  //  for (let entry of file_sent) {
     /// console.log(entry); // 1, "string", false

     // match outloo .php upload file.
     const result1 = entry.name.replaceAll(' ', '-'); // normal
     const result2 = entry.name.replace(/\s+/g, '-'); //regx
    this.created_file_name_strip = result1.replace(/[^a-zA-Z0-9]/g,'-');
   //  this.created_file_name_strip = result1.replace(/[^A-Za-z0-9\-]/,'-');
    
     this.created_file_name = entry.name;
     

     this.file_edit_level = 3;

     // agemt security: if agent creating then remove other agents from array first
     if(this.gfunc.sessionUserLevel == 5) {
     this.RemoveElementOthersFromAllAgentRecipients(this.gfunc.sessionBrandId); // adds the logged in agents
     }
     //need to loop through all files and do a seperate insert for each.
     // this.created_file_name = fileupload_data;

     // finds last period .  and removes all before. ie extension of a file.
     const ext = this.created_file_name.substr(this.created_file_name.lastIndexOf('.') + 1);

     const file_server_location = this.gfunc.file_server_location_JobAssets + '/' + this.job_id;
     // need to make this transportable.
     const file_url = this.gfunc.baseUploadURL_JobAssets + '/' + this.job_id + '.' + this.created_file_name_strip + '.' + ext;
     // const file_url = this.gfunc.baseUploadURL_JobAssets + '/' + this.job_id + '.' + this.created_file_name;
     const file_folder = this.gfunc.file_folder_jobAssets + '/' + this.job_id;



     // const file_name = this.created_file_name.slice(0, -5); // removes the extension
     const file_name = this.created_file_name_strip + '.' + ext;

     const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
     // UPGRADE Document Model (Insert the File into the database)
     // File Json
     this.create_file = {
       file_name: file_name,
       file_display_name: file_name,
       file_ext: ext,
       file_server_location: file_server_location,
       file_url: file_url,
       file_folder: file_folder,
       file_make: 'uploaded', // automated / updated / created / uploaded / link_created
       file_notes: 'File created via a client upload',
       file_job_id: this.job_id,
       file_subject_id: this.subject_id,
       file_subject_number: this.subject_number,
       created_by: this.gfunc.sessionUserId,
       created_date: this.gfunc.today,
       created_level: this.gfunc.sessionUserLevel,
   
    // file_brand_id: this.gfunc.sessionBrandId, //?? should this be the subject client report brand id???? upon upload
    file_brand_id: this.permission_model.file_brand_id,  // if an agent or a client file or woner. comes from the form drop downs.
    brand_type_id: this.permission_model.brand_type_id,  // if an agent or a client file
       file_access_level: 9, // ? who can access this file and below (client 9 or agent 5 staff 4 manager 3 admin 2 master 1
       is_active: '1',
       file_password: '',
       file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
       updated_by: null,
       updated_date: null,
       prev_file_id: null,    // if updating
       subject_template_doc_id: null,
       subject_com_type_id: null,
       random_file_name: random_file_name,
       full_file_name: this.created_file_name_strip + '.' + ext ,
       // full_file_name: this.created_file_name,
       name: entry.name,
       size: entry.size,
       type: entry.type,
       file_number: this.file_number,
       reference_number: this.reference_number,
       // arrays of sending to - based on subject_template_doc - setup
       agent_access_array: '[]', // collect current agent ids
       report_access_array: '[]', // collect client
       invoice_access_array: '[]', // collect client
       user_access_array: '[]', // of selected associated users.
       // Give Access to Users associated with this job, agents, client invoice user, client report user
       assigned_to_agents: JSON.stringify(this.allAgentRecipients),
       is_encrypted: 0


       
     //  subject_service_id: model.subject_service_id,
       //  Need to fix message sysetm to send to real invoice and primary user for company, and
       //  TO DO :  create a send to company listed contact email, as well as fix above,
       //  This means that a user that is a company invoice user, or a primary user (First user created with the account)
       /* 
             agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
             report_access_array: JSON.stringify(this.brand_data), // collect client
             invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
             user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users. */
     } as SystemFile;  /// Rixes the deserialisation errors!!! as File (model)
     // console.log( (JSON.stringify(this.assignedBrandList)) );



     this.uploadDiagnostics.markFileStage(uploadDiag, 'file_metadata_prepare_success', {
       fileName: file_name,
       fileUrl: file_url
     });
    this.createFile(this.create_file, uploadDiag, uploadItem);  /// run this inside the function to get the insert file ID for Note.





  // } // end loop entry of uploaded files

 }

 createFile(model, uploadDiag?: UploadDiagnosticFile, uploadItem?: UploadUiItem) {
   this.uploadDiagnostics.markFileStage(uploadDiag, 'api_file_create_request_start', {
     endpoint: '/api/file/create'
   });
   this._demoService.createFile(model).subscribe(
     data => {
       this.uploadDiagnostics.markFileStage(uploadDiag, 'api_file_create_request_success', {
         response: data
       });
       this.file_created_response = data;
       const res = data;
       // need to get the returned ID to send to log create action
       // this.returned_created_file_id = this.file_created_response.last_insert_id;
       this.returned_created_file_id = this.file_created_response.last_insert_id;
       if (uploadItem) {
         uploadItem.file_create_id = this.returned_created_file_id;
       }

       let notice_model = [];
       let inserted_file_id = this.returned_created_file_id;
       console.log('InsideFunction Loop: file_ID: ' + this.returned_created_file_id);

       // Now insert the note
       const brand_type_id = this.permission_model.brand_type_id;
       const log_action = 'uploaded';
       const log_name = 'Client Uploaded a job file: ' + this.job_id + ' - ' + this.created_file_name + '';
       this.create_sys_log = {
         log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
         log_action: log_action, // automated / updated / created / uploaded / link_created / sent
         created_by: this.gfunc.sessionUserId,
         created_date: this.gfunc.today,
         subject_id: this.subject_id,
         job_id: this.job_id,
         job_reference_number: this.job_id,
         file_number: this.file_number,
         reference_number: this.reference_number,
         subject_number: this.subject_number,
         // subject_number: model.file_subject_number,
         log_type_id: 1, // see datatable system_log_types
         created_level: this.gfunc.sessionUserLevel,
         brand_type_id: brand_type_id,
         subject_com_type_id: null,
         subject_template_doc_id: null,
         log_name: log_name + ' - ' + this.created_file_name,
         file_id: inserted_file_id,
         last_insert_id: this.returned_created_file_id,
         file_name: this.created_file_name
       } as SystemLog;

       // Set a delay function in javascript. per second to make sure we have the value.

       // this.createSystemLog(this.create_sys_log);
       notice_model = {
         ...model,
         ...this.create_sys_log,
         upload_diagnostic: this.uploadDiagnosticForLog(uploadDiag, uploadItem)
       };

       if(this.subject_id >= 1){
         // subject file
       this.setUploadItemStatus(uploadItem, 'logging', 'File saved; creating subject upload log', 96);
       this.uploadDiagnostics.markFileStage(uploadDiag, 'system_log_subject_dispatch_start', {
         logTypeId: 34
       });
       this.gfunc.insertLog_UploadSubjectFile(notice_model);
       }
       if(this.subject_id == undefined) {
         // job file
         this.setUploadItemStatus(uploadItem, 'logging', 'File saved; creating job upload log', 96);
         this.uploadDiagnostics.markFileStage(uploadDiag, 'system_log_job_dispatch_start', {
           logTypeId: 26
         });
         this.gfunc.insertLog_UploadJobFile(notice_model);
         }

      //   this.toastr.info('attempting to auto attach to attempt report for you ...');

       
      
      
      // Need to know I have all newly created file details to automatically add to the array
       //  this.onAddAttemptFile(this.returned_created_file_id, this.attach_file_array_name);


/// Clean the form just in case
        // reset the form
        this.sendableFormData.delete;
        this.files = [];
        this.file = '[]';


       this.setUploadItemStatus(uploadItem, 'complete', 'Complete', 100);
       console.log(this.returned_created_file_id);
      this.toastr.success('File uploaded successfully and permissions have been set.');
     },
     err => {
       this.uploadDiagnostics.markError(uploadDiag, 'api_file_create_request_error', err);
       this.setUploadItemFailed(uploadItem, 'File record save failed: ' + (err && err.message ? err.message : err));
       console.error(err);
     },
     // () => console.log('done loading Trace Types')
   );
 }

 createSystemLog(model) {
   this._demoService.createSystemLog(model).subscribe(
     data => { this.system_log_created_response = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 // Function setup to lookup file details and add to arrays of the attempt page automatically.
onAddAttemptFile(file_id, attach_file_array_name){
  // need to lookup the file
  // htne fill the sysetm 

            this._demoService.getSystemFile(file_id).subscribe(
              data => { this.file_data = data;
            let res = data[0];

// Buld here and run the module.



         // add the file to attempt
         // auot add to array - 
         this.created_file = [{
          // log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
          // log_action: log_action, // automated / updated / created / uploaded / link_created / sent
          // created_by: this.gfunc.sessionUserId,
          // created_date: this.gfunc.today,
          // subject_id: this.subject_id,
          // job_id: this.job_id,
          // job_reference_number: this.job_id,
          // file_number: this.file_number,
          // reference_number: this.reference_number,
          // subject_number: this.subject_number,
          // // subject_number: model.file_subject_number,
          // log_type_id: 1, // see datatable system_log_types
          // created_level: this.gfunc.sessionUserLevel,
          // brand_type_id: brand_type_id,
          // subject_com_type_id: null,
          // subject_template_doc_id: null,
          // log_name: log_name + ' - ' + this.created_file_name,
          // file_id: inserted_file_id,
          // last_insert_id: this.returned_created_file_id,
          // file_name: this.created_file_name

          file_name: this.created_file_name,
          job_file: 0,
          subject_file: 1,
          file_id: res.file_id,
          file_server_location: res.file_server_location,
          file_ext: res.file_ext,
          file_brand_id: res.file_brand_id,
          file_access_level: res.file_access_level,
          assigned_to_agents: res.assigned_to_agents,
          brand_type_id: res.brand_type_id


        }];         
        

        
        
        // set the variable and addd to the model to auto add the attmpt files to the correct array
        ///this.file_data[0].attach_file_array_name = this.attach_file_array_name;
///// re model quicky to add the record of the array name to the data model
        this.file_data = [{
          ...this.file_data[0],
          attach_file_array_name: this.attach_file_array_name
        }]

        console.log('Created File: ', JSON.stringify(this.file_data) );

        
        this.file_data = DataUtil.parse.parseJson(this.file_data); // needs to be in grid format for orginal add onAdd Grid Button.
     // switched off for now and ecourage to attach using button rather than auto.
        this.onAdd.emit(this.file_data);



          // this.toastr.success('Lookup and Attached to Current Attempt');
            },
              err => {
                console.error(err);
                this.toastr.error('Unable to add to attempt files correctly');
              },
              // () => console.log('done loading Trace Types')
             
            );





}

 // :: end file upload database and Insert Log


// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_comms(subject_id) {
 this.allAgentRecipients = [];
 this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
    data => { 
      this.assignedAgentsList2 = data;

      let newArr = data;
      let  count_of_items = Object.keys(newArr).length;
        // need to do a loop of subject_billing items (.length)
        for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
        this.allAgentRecipients.push({
          recipient_name: res.name + '',
          recipient_email_address: res.email,
          recipient_brand_id: res.brand_id,
          recipient_subject_id: res.subject_id,
          recipient_brand_type_id: res.brand_type_id,
          recipient_user_id: null,
          recipient_user_level_id: null,
          recipient_type_name: 'Agent',
        });
        } // end for loop
      this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
      // set records to send to subject_notes data table
     //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

   },
    err => console.error(err),
    // () => console.log('Loaded Assigned Agents Loaded.')
  );
}



RemoveElementFromAllRecipients_comms(key: number) {
 // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
 this.allAgentRecipients.forEach((value, index) => {
   if (value.recipient_name === key) {
     this.allAgentRecipients.splice(index, 1);
   }
 });
   // :: Specifcally removes the array item without there being
   // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};




RemoveElementOthersFromAllAgentRecipients(key: number) {
 // test! -- load again an then filter and create the array again.
 // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.

 // delay load slightly so I can refresh the allRecpientList first.
 setTimeout(function() {   
}, 2000);
   console.log("Ready to clean array!")

 let array = this.allAgentRecipients;
 // removes all not matching
   // :: Specifcally removes the array item without there being
   // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
   this.allAgentRecipients.forEach((value, index) => {
   if (value.recipient_brand_id !== key) {
     this.allAgentRecipients.splice(index, 1);
   }
 });
 // console.log('allAgentRecipients after Removal Others: ', JSON.stringify(this.allAgentRecipients));

// ::@https://stackoverflow.com/questions/5310304/remove-json-element
// let json = this.allRecipients
// let id_key = "recipient_brand_id";
// delete json[id_key]; // Removes json.foo from the dictionary.



};








// public files: NgxFileDropEntry[] = [];

// public dropped(files: NgxFileDropEntry[]) {
 public dropped(files) {  
this.files = files;


console.log('Files:', JSON.stringify(this.files))



// for (const file of files) {

//     // Is it a file? 
 
//       const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

// // if (droppedFile instanceof DataTransferItem){
// //   console.log('instance');
// // }

//       files.file((file: File) => {

//         // Here you can access the real file
//         console.log(droppedFile.relativePath, file);

//         // check droppedFile is instanceof DataTransferItem

//   // apends the value to the form.
//   const formData = new FormData()
//   formData.append('job_id', this.item_id);

//   // this.changeFile(file);



//   formData.append('file[]', file, droppedFile.relativePath)

//   // this.sendableFormData.append('subject_id', this.subject_id);
//         //  const req = new HttpRequest<FormData>(
//         //    'POST',
//         //    this.url,
//         //    formData, {
//         //    reportProgress: true, responseType: 'text'
//         //  },
//         //  );

//       // Headers
//       const headers = new HttpHeaders({
//         'security-token': 'mytokenMEOW'
//       })

//    this.http.post(this.url, formData, { headers: headers, responseType: 'text' })
//    .subscribe(data => {
//      // Sanitized logo returned from backend
//      console.log(data);
   
//      this.toastr.success('file uploaded');
//    })


// // now upload
// this.createJobFileData([],files);


//         /**
//         // You could upload it like this:
//         const formData = new FormData()
//         formData.append('logo', file, relativePath)

//         // Headers
//         const headers = new HttpHeaders({
//           'security-token': 'mytoken'
//         })

//         this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
//         .subscribe(data => {
//           // Sanitized logo returned from backend
//         })
//         **/

//       });
   
//   }



}









}
